module.exports = __webpack_public_path__ + "img/2.be7fb2a5.jpg";